import { createReducer } from 'store/createReducer';
import { ConservatorySizeModel } from 'models/ConservatorySizeModel';
import { ConservatoryStepValid } from 'models/ConservatoryStepValid';
import {
  GUIDE_SIZE_DATA_LOADING,
  GUIDE_SIZE_DATA_LOADED,
  GUIDE_SIZE_VALID,
  GUIDE_SIZE_INVALID,
  GUIDE_SIZE_TOGGLE_CORNERS,
  GUIDE_SIZE_SELECT_WIDTH,
  GUIDE_SIZE_SELECT_DEPTH,
  GuideSizeAction,
  GuideSizeSelectAction,
  GuideSizeCornerAction
} from './actions';
import { GUIDE_MAKE_PRODUCT_SELECTED } from '../Make/actions';

const sizeReducer = {
  [GUIDE_MAKE_PRODUCT_SELECTED]: (state: ConservatorySizeModel) => {
    return {
      ...state,
      products: [],
      cornerLeft: false,
      cornerRight: false,
      selectedWidth: 0,
      selectedDepth: 0
    };
  },
  [GUIDE_SIZE_VALID]: (state: ConservatorySizeModel) => {
    return {
      ...state,
      isValid: ConservatoryStepValid.Valid
    };
  },
  [GUIDE_SIZE_INVALID]: (state: ConservatorySizeModel) => {
    return {
      ...state,
      isValid: ConservatoryStepValid.Invalid
    };
  },
  [GUIDE_SIZE_DATA_LOADED]: (state: ConservatorySizeModel, action: GuideSizeAction) => {
    const selectedDepth = 0;
    const selectedWidth = 0;

    return {
      ...state,
      products: action.products.map(p => {
        if (p.depth === selectedDepth && p.width === selectedWidth) {
          p.selected = true;
        }
        return p;
      }),
      dataLoading: false,
      selectedDepth,
      selectedWidth
    };
  },
  [GUIDE_SIZE_DATA_LOADING]: (state: ConservatorySizeModel) => {
    return {
      ...state,
      dataLoading: true,
      cornerLeft: false,
      cornerRight: false,
      selectedWidth: 0,
      selectedDepth: 0
    };
  },
  [GUIDE_SIZE_TOGGLE_CORNERS]: (state: ConservatorySizeModel, action: GuideSizeCornerAction) => {
    return {
      ...state,
      cornerLeft: action.cornerLeft,
      cornerRight: action.cornerRight,
      selectedWidth: 0,
      selectedDepth: 0,
      products: state.products.map(product => {
        return {
          ...product,
          selected: false
        };
      })
    };
  },
  [GUIDE_SIZE_SELECT_WIDTH]: (state: ConservatorySizeModel, action: GuideSizeSelectAction) => {
    return {
      ...state,
      selectedWidth: action.size,
      products: state.products.map(product => {
        return {
          ...product,
          selected: product.depth === state.selectedDepth && product.width === action.size
        };
      })
    };
  },
  [GUIDE_SIZE_SELECT_DEPTH]: (state: ConservatorySizeModel, action: GuideSizeSelectAction) => {
    return {
      ...state,
      selectedDepth: action.size,
      products: state.products.map(product => {
        return {
          ...product,
          selected: product.width === state.selectedWidth && product.depth === action.size
        };
      })
    };
  }
};

export default createReducer(
  {
    cornerLeft: false,
    cornerRight: false,
    dataLoading: false,
    isValid: ConservatoryStepValid.Unknown,
    products: [],
    selectedDepth: 0,
    selectedWidth: 0
  },
  sizeReducer
);
